import { render } from "./ProjectValidationDashboard.vue?vue&type=template&id=451408bc&scoped=true"
import script from "./ProjectValidationDashboard.vue?vue&type=script&lang=js"
export * from "./ProjectValidationDashboard.vue?vue&type=script&lang=js"

import "./ProjectValidationDashboard.vue?vue&type=style&index=0&id=451408bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-451408bc"]])

export default __exports__